<template>
  <button :disabled="loading" class="center items-center" style="font-weight: 700; background-size: contain;  background-repeat: no-repeat; background-position: center;">
    <div v-if="loading" class="btn-spinner mr-2" />
    <slot />
  </button>
</template>

<script>
export default {
  props: {
    loading: Boolean,
  },
}
</script>
